import React from "react";
import { Box, Stack, Typography, Button, Chip } from "@mui/material";
import hero from "./promote-hero.png";
import { useNavigate } from "react-router-dom";

export default function HeroBanner() {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        position: "relative",
        borderRadius: 3,
        overflow: "hidden",
        minHeight: { xs: 220, md: 320 },
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        mb: 2,
        bgcolor: "background.default",
      }}
    >
      {/* Background image */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          backgroundImage: `url(${hero})`,
          backgroundSize: "contain",
          backgroundPosition: "center",
          opacity: 0.35,
          filter: "grayscale(20%)",
        }}
      />
      {/* Gradient vignette */}
      <Box
        sx={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(60% 60% at 50% 50%, rgba(240,185,11,0.20) 0%, rgba(0,0,0,0.9) 100%)",
        }}
      />
      {/* Content */}
      <Stack
        spacing={1.2}
        sx={{
          position: "relative",
          p: { xs: 2, md: 4 },
          textAlign: "center",
          maxWidth: 880,
        }}
        alignItems="center"
      >
        <Chip
          label="PROMOTE & EARN"
          sx={{
            bgcolor: "brand.main",
            color: "white",
            fontWeight: 700,
            letterSpacing: 1,
          }}
        />
        <Typography variant="h4" fontWeight={800} sx={{ color: "white" }}>
          Create. Share. Earn USDT.
        </Typography>
        <Typography variant="body1" sx={{ opacity: 0.9, color: "white" }}>
          Make a short positive video about deposits, withdrawals, security &
          support, AI trading, or a general intro. Submit your link and
          screenshot — get rewarded when approved.
        </Typography>
        <Stack direction="row" spacing={1} sx={{ mt: 1 }}>
          <Button
            variant="contained"
            size="large"
            sx={{
              bgcolor: "brand.main",
              color: "white",
              "&:hover": { bgcolor: "brand.dark" },
              borderRadius: 2,
            }}
            href="#promote-form"
          >
            Start Now
          </Button>
          <Button
            variant="outlined"
            sx={{
              borderRadius: 2,
              borderColor: "rgba(255,255,255,0.5)",
              color: "white",
              "&:hover": { borderColor: "rgba(255,255,255,0.8)" },
            }}
            onClick={() => {
              navigate("/promotions/leaderboard");
            }}
          >
            View Leaderboard
          </Button>
        </Stack>
      </Stack>
    </Box>
  );
}
